/**
 * Mirror cliente do catálogo de Push Notifications. Mantenha sincronizado
 * com `functions/src/shared/notifications.ts` — qualquer divergência vira
 * routing morto no service worker.
 */

export const NOTIFICATION_TYPES = [
  "streak_at_risk",
  "weekly_recap",
  "badge_close",
  "league_promote_risk",
  "league_closed",
  // Ultrapassagem na liga (13/09) — espelho do servidor, mesma posição.
  "league_overtaken",
  // Marcos da temporada (16/09) — espelho do servidor, mesma posição.
  "league_season_open",
  "league_season_half",
  "league_season_last_week",
  "league_season_closed",
  // Livro da vez do clube do livro (05/10, F6) — espelho do servidor, mesma posição.
  "league_club_book",
  // Chamada para votar no clube (13/10, C6) — espelho do servidor, mesma posição.
  "league_club_vote",
  // `monthly_digest` faltava aqui desde que o cron nasceu — o espelho tinha 5
  // e o servidor 6. Corrigido em 07/08 junto do BUG-102; a paridade agora é
  // travada por teste (`tests/functions/pushTypeParity.test.ts`).
  "monthly_digest",
  // Escada de reengajamento (27/08) — espelho do servidor, mesma posição.
  "streak_lost",
  "reading_invite",
  "new_follower",
  // Convite para clube pelo app (06/10) — espelho do servidor, mesma posição.
  "club_invite",
  "beta_approved",
  // Aviso do admin dirigido a pessoas específicas (05/09) — espelho do
  // servidor, mesma posição.
  "admin_message",
  "support_reply",
  // Lançamentos (18/10, A5) — espelho do servidor, mesma posição.
  "release_announced",
  "release_day",
  "release_changed",
  // Aviso semanal das editoras seguidas (21/10, D49) — espelho do servidor, mesma posição.
  "release_digest",
  // Autoria verificada (20/10, A1c) — espelho do servidor, mesma posição.
  "author_claim",
] as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

export const FCM_TOKENS_MAX = 5;
